import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { queryClient } from '@/app/queryClient';
import { ToastProvider } from '@/components/toast/ToastProvider';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { theme } from '@/theme';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme} defaultMode="system">
        <CssBaseline />
        {/* Router first: AuthProvider is consumed by route guards, and its
            own redirects need router context to exist. */}
        <BrowserRouter>
          {/* Inside the router, because a toast is raised by things that also navigate. */}
          <AuthProvider>
            <ToastProvider>{children}</ToastProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
